export default __webpack_public_path__ + "static/media/Visa.2b23ce1d.svg";